The response from the `createWebhookSubscription` mutation.
